module.exports = __webpack_public_path__ + "static/media/mz.5a4a3d84.svg";